import React from "react";

export const EditIcon = React.memo(() => {
    return (
        <svg style={{minWidth: 13}} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.21903 0.476556L7.98879 1.7067L11.2932 5.01082L12.5234 3.78067C13.1589 3.14527 13.1589 2.11591 12.5234 1.4805L11.5219 0.476556C10.8865 -0.158852 9.85703 -0.158852 9.22157 0.476556H9.21903ZM7.41433 2.28111L1.48933 8.20819C1.22498 8.47252 1.03181 8.80039 0.925049 9.15876L0.0252421 12.2163C-0.0383036 12.4324 0.0201585 12.6637 0.177752 12.8212C0.335345 12.9788 0.566651 13.0373 0.780165 12.9763L3.83798 12.0766C4.19638 11.9698 4.52428 11.7766 4.78863 11.5123L10.7187 5.58523L7.41433 2.28111Z" fill="#8B8E91"/>
        </svg>
    )
});